<template>
    <div>
        <ForeignOfficeTable/>
    </div>
</template>

<script setup>
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ForeignOfficeTable from "@/components/dashboard/foreign-office/ForeignTable.vue";

</script>
